export const MULTI_VALUED_LIST_VISIBLE_COUNT_BY_SCREEN = {
  desktop: 3,
  mobile: 1,
  tablet: 2,
}
